module.exports = __webpack_public_path__ + "img/lesotho.144bb4f0.svg";